import React from "react";
import Page from "components/Page";
import { Props } from "./CommunicationCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const CommunicationCustomTypes = lazyWithRetry(() =>
  import("./CommunicationCustomTypes")
);

export default (props: Props) => (
  <Page>
    <CommunicationCustomTypes {...props} />
  </Page>
);
